import { Flex, Image } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import ScanImage from "images/inbound/inbound-index-page-scan.png";
import { BodyM, HeaderS } from "ui/Typography/Typography";

export function BatteryCountScan() {
  return (
    <Flex
      h="full"
      w="full"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      gap="s200"
      bgColor="white"
    >
      <HeaderS>
        <FormattedMessage id="pages.inventory.battery-management-page.placeholders.battery-count-scan.title" />
      </HeaderS>
      <BodyM color="grey.800" maxW="293px">
        <FormattedMessage id="pages.inventory.battery-management-page.placeholders.battery-count-scan.body" />
      </BodyM>
      <Image src={ScanImage} h="124px" w="124px" />
    </Flex>
  );
}
